
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"31.121","height":"26.741"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 713","fill":"#088dd1","fill-rule":"evenodd"}},[_c('path',{attrs:{"data-name":"Path 6928","d":"M9.023 15.89c3.555-.34 7.5-1.919 11.361-2.407q.021-.251.021-.507A6.063 6.063 0 109.023 15.89z"}}),_c('path',{attrs:{"data-name":"Path 6929","d":"M3.608 7.378a12.222 12.222 0 0110.658-6.233 12.186 12.186 0 018.517 3.456l-5.938 1.014 6.7-.206q.281.327.539.674l-2.823.513h3.184a12.167 12.167 0 012.048 6.775q0 .339-.018.674l1.1.579q.058-.619.058-1.253A13.371 13.371 0 0014.266 0 13.373 13.373 0 00.974 11.908a2.655 2.655 0 001.065 1.4q1.236-1.815 6.139-.907a7.565 7.565 0 003.189-.082 2.768 2.768 0 00-2.044-.245q.057-1.127-1.145-1.063-.205-1.993-2.289-1.635.395-2.03-2.282-2zm-3.608 4c3.01 15.783 19.03 1.844 28.615 4.742C18.987 9.95 6.083 24.675 0 11.378zm.054 3.21a11.469 11.469 0 003.6 6.377c9.369 7.816 16.934-5.729 27.47-2.453-5.279-5.362-15.63 2.227-22.892 2.289q-5.6-.641-8.176-6.213zm18.1-10.273q-.255-.544-1.08-.262a1.033 1.033 0 00-1.16-.44 1.483 1.483 0 011.064.654 3.973 3.973 0 011.176.048zm-7.245 2.8q-.539-.266-1.008.467a1.033 1.033 0 00-1.181.378 1.483 1.483 0 011.24-.15 3.976 3.976 0 01.95-.694zm13.552 4.111q-.521-1-2.044-.409a1.939 1.939 0 00-2.207-.736 2.782 2.782 0 012.044 1.145 7.447 7.447 0 012.207 0zm.666 7.762c-5.751 1.594-10.578 6.361-17.035 4.941a11.211 11.211 0 01-2.858-.7 13.322 13.322 0 009.03 3.51 13.374 13.374 0 0012.216-7.927 6.222 6.222 0 00-1.352.171z"}})])])
          )
        }
      }
    